import "../../styles/PagesStyles/PrivacyPolicy.css"
import usePageTitle from "../../hooks/usePageTitle";

const PrivacyPolicy = () => {
  usePageTitle("Combat Solutions AI | Privacy Policy");
  return (
    <section className="policy-section">
      <div className="policy-container">

        {/* Page Header */}
        <div className="policy-header">
          <h1>Data Privacy Policy</h1>
          <p>
            These Terms define the rights, responsibilities, and obligations when
            accessing Combat Solutions AI services.
          </p>
          <div className="policy-divider"></div>
        </div>

        {/* Introduction */}
        <h2>Introduction</h2>
        <p>
          We at Combat Solutions value and respect the privacy of the data that
          our clients, prospects, and visitors provide us. Combat Solutions, its
          subsidiaries, and affiliates (collectively referred to as “Combat
          Solutions”, “We”, or “Us”) are committed to protecting the Personal
          Information we collect through our website and during our professional
          interactions, campaigns, and recruitment processes.
        </p>
        <p>
          By visiting our website or providing your personal information to us,
          you accept and consent to the terms of this Data Privacy Policy.
        </p>

        {/* Information Collection */}
        <h2>Information Collection</h2>
        <p>
          We define “Personal Information” as any data relating to an individual
          who can be identified from that data. We collect information in the
          following ways:
        </p>

        <ul>
          <li>
            <strong>Direct Interaction:</strong> Information you provide via web
            forms, live chat, email, or telephone (e.g., Name, Email,
            Designation, Company, Phone Number).
          </li>
          <li>
            <strong>Technical Means:</strong> Automated collection through
            cookies and IP addresses to understand browser type and operating
            system.
          </li>
          <li>
            <strong>Recruitment:</strong> Resumes and professional history
            collected from candidates applying for roles.
          </li>
          <li>
            <strong>Third Parties:</strong> Information received from business
            partners or service vendors.
          </li>
        </ul>

        {/* How We Use Your Information */}
        <h2>How We Use Your Information</h2>
        <p>Combat Solutions uses your data for:</p>

        <ul>
          <li>
            <strong>Communication:</strong> To provide requested services,
            customer support, and company updates.
          </li>
          <li>
            <strong>AI Service Optimization:</strong> To operate, maintain, and
            improve our Generative AI models and IT solutions.
          </li>
          <li>
            <strong>Recruitment & HR:</strong> To evaluate candidates for
            employment opportunities.
          </li>
          <li>
            <strong>Safety & Fraud Prevention:</strong> To prevent unauthorized
            access and protect digital assets.
          </li>
        </ul>

        {/* Information Sharing */}
        <h2>Information Sharing and Disclosure</h2>
        <p>
          We do not sell your Personal Data to third parties for marketing
          purposes. We share data only with:
        </p>

        <ul>
          <li>
            <strong>Internal Teams:</strong> Within Combat Solutions for business
            and administrative purposes.
          </li>
          <li>
            <strong>Service Vendors:</strong> Cloud-based providers (e.g.,
            Azure/AWS) for storage and retrieval.
          </li>
          <li>
            <strong>Legal Requirements:</strong> When required by law,
            regulators, or law enforcement agencies.
          </li>
          <li>
            <strong>Corporate Transactions:</strong> In the event of a merger,
            acquisition, or asset sale.
          </li>
        </ul>

        {/* Data Security */}
        <h2>Data Security</h2>
        <p>
          Combat Solutions implements industry-standard security measures,
          including encryption, firewalls, and strict access controls. Our
          databases are accessible only by authorized personnel bound by
          confidentiality and non-disclosure agreements.
        </p>

        {/* Rights */}
        <h2>Your Rights (Access and Correction)</h2>
        <p>
          Subject to local laws, you have the following rights regarding your
          data:
        </p>

        <ol>
          <li>The right to access a copy of the data we hold about you.</li>
          <li>The right to rectification of inaccurate or incomplete data.</li>
          <li>
            The right to erasure (right to be forgotten) where there is no legal
            reason to continue processing your data.
          </li>
          <li>
            The right to withdraw consent where processing is based on consent.
          </li>
        </ol>

        {/* Protection of Minors */}
        <h2>Protection of Minors</h2>
        <p>
          Our website and services are not directed to children under the age of
          sixteen (16). We do not knowingly collect information from minors.
        </p>

        {/* External Links */}
        <h2>External Links</h2>
        <p>
          Our website may contain links to social media or partner websites.
          Combat Solutions is not responsible for the privacy practices of these
          external sites.
        </p>

        {/* Changes */}
        <h2>Changes to This Policy</h2>
        <p>
          This policy may be updated periodically. Any changes will be posted on
          this page with an updated effective date.
        </p>

        {/* Contact */}
        <h2>Contact Us & Grievance Redressal</h2>
        <p>
          In case of any grievances, questions, or requests regarding your
          personal data, please contact:
        </p>

        <p>
          <strong>Name:</strong> Harshad Gangurde<br />
          <strong>Designation:</strong> HR Executive<br />
          <strong>Company:</strong> Combat Solutions<br />
          <strong>Location:</strong> Nashik, Maharashtra<br />
          <strong>Email:</strong>{" "}
          <a
            href="mailto:hrd@combatsolutions.co.in"
            className="policy-email"
          >
            hrd@combatsolutions.co.in
          </a>
        </p>

      </div>
    </section>
  );
};

export default PrivacyPolicy;
